function EmployeeDeploymentAvatar({ first_name, last_name, index, isDragging = false, size = "normal" }) {
  const colors = ['bg-blue-500', 'bg-green-500', 'bg-purple-500', 'bg-pink-500', 'bg-yellow-500', 'bg-indigo-500', 'bg-red-500', 'bg-gray-500']
  const colorClass = colors[index % colors.length]

  const sizeClasses = size === "small"
    ? "w-10 h-10 text-xs"
    : "w-12 h-12 text-xs"

  return (
    <div className={`${sizeClasses} ${colorClass} rounded-full flex items-center justify-center text-white font-bold ${isDragging ? 'opacity-50' : ''} cursor-grab transition-all duration-200 hover:scale-105 shadow-sm`}>
      {first_name.charAt(0)}{last_name.charAt(0)}
    </div>
  )
}

export default EmployeeDeploymentAvatar
